import { render, staticRenderFns } from "./selectionCriteria.vue?vue&type=template&id=50ecdf17&scoped=true&"
import script from "./selectionCriteria.vue?vue&type=script&lang=js&"
export * from "./selectionCriteria.vue?vue&type=script&lang=js&"
import style0 from "./selectionCriteria.vue?vue&type=style&index=0&id=50ecdf17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ecdf17",
  null
  
)

export default component.exports